import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";
import { getSchedulePeriods, SCHEDULE_DAYS } from "./schedulePeriods";

const getComparableTimes = (schedule) => {
  const daySchedules =
    schedule?.dayTimes?.dayTimes || schedule?.dayTimes || {};

  return SCHEDULE_DAYS.map((day) =>
    getSchedulePeriods(daySchedules[day]).sort(
      (left, right) =>
        left.startTime.localeCompare(right.startTime) ||
        left.endTime.localeCompare(right.endTime),
    ),
  );
};

const ScheduleTypeWidget = ({
  id,
  label,
  value,
  required,
  disabled,
  readonly,
  onChange,
  onBlur,
  onFocus,
  options,
  formContext,
  rawErrors = [],
}) => {
  const [pendingType, setPendingType] = useState(null);
  const handleChange = (event) => {
    const nextType = event.target.value;
    const schedule = (
      formContext.formDataRef?.current || formContext.formData
    ).scheduleVariableFlexible;
    const committedSchedule = formContext.savedScheduleRef?.current;
    const savedSchedule =
      committedSchedule?.scheduleType === value ? committedSchedule : null;
    const hasChangedTimes =
      JSON.stringify(getComparableTimes(schedule)) !==
      JSON.stringify(getComparableTimes(savedSchedule));

    if (value && nextType !== value && hasChangedTimes) {
      formContext.setScheduleTypeDropdownOpen(false);
      setPendingType(nextType);
      return;
    }
    onChange(nextType);
  };

  return (
    <>
      <TextField
    id={id}
    label={label}
    value={value ?? ""}
    required={required}
    disabled={disabled || readonly}
    error={rawErrors.length > 0}
    fullWidth
    select
    onChange={handleChange}
    onBlur={() => onBlur?.(id, value)}
    onFocus={() => onFocus?.(id, value)}
    SelectProps={{
      open: formContext.scheduleTypeDropdownOpen,
      onOpen: () => formContext.setScheduleTypeDropdownOpen(true),
      onClose: () => formContext.setScheduleTypeDropdownOpen(false),
    }}
  >
    {(options.enumOptions || []).map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
      </TextField>
      <Dialog
        open={pendingType !== null}
        onClose={() => setPendingType(null)}
        aria-labelledby={`${id}-confirm-title`}
        aria-describedby={`${id}-confirm-description`}
        maxWidth="xs"
      >
        <DialogTitle id={`${id}-confirm-title`}>
          Schedule Type Change
        </DialogTitle>
        <DialogContent>
          <DialogContentText id={`${id}-confirm-description`}>
            Changing the schedule type will clear the times you entered. Are you sure want to Continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            size="small" 
            color="primary"
            variant="outlined"
            onClick={() => setPendingType(null)}
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => {
              onChange(pendingType);
              setPendingType(null);
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ScheduleTypeWidget;
